"use client";

import * as React from "react";
import { MenuIcon } from "lucide-react";

import { Button } from "@/components/ui/button";
import { Drawer, DrawerContent, DrawerTrigger } from "@/components/ui/drawer";
import { Stack } from "@/components/ui/stack";

import type { NavigationConfig } from "@/config/nav";

import { DevBadge } from "./dev-badge";
import { NavigationLinkItem } from "./navigation-link-item";
import { NavigationMenuItem } from "./navigation-menu-item";

export function MobileNav({ config }: { config: NavigationConfig }) {
  const [open, setOpen] = React.useState(false);

  // Mobile config always includes home link
  const mobileConfig: NavigationConfig = React.useMemo(() => {
    return [
      {
        label: "Home",
        href: "/",
      },
      ...config,
    ];
  }, [config]);

  return (
    <Stack direction="row" align="center" gap={0} className="md:hidden">
      <Drawer open={open} onOpenChange={setOpen}>
        <DrawerTrigger asChild>
          <Button
            variant="ghost"
            className="-ml-2 mr-2 h-8 w-8 hover:bg-transparent focus-visible:bg-transparent focus-visible:ring-0 focus-visible:ring-offset-0"
          >
            <MenuIcon />
            <span className="sr-only">Toggle Menu</span>
          </Button>
        </DrawerTrigger>
        <DrawerContent className="max-h-[60svh] p-0">
          {mobileConfig.map((item) => (
            <div className="py-1" key={item.label}>
              {item.kind === "menu" ? (
                <NavigationMenuItem item={item} fullWidth />
              ) : (
                <NavigationLinkItem item={item} fullWidth />
              )}
            </div>
          ))}
        </DrawerContent>
      </Drawer>
      <DevBadge />
    </Stack>
  );
}
